import React, { Fragment } from 'react';
import beautifyNumber from 'helpers/beautifyNumber';

import { renderSimpleItem } from './render-common';

// рендер минимальной цены
export function renderMinPrice(
  bemClasses,
  min_price, soldData = {}, sales_suspended_until,
  key
) {
  const { i18n } = this;
  const soldOrSuspendedTxt = renderSoldData.call(this, bemClasses, soldData, sales_suspended_until);
  if (!min_price) {
    if (soldOrSuspendedTxt && bemClasses) {
      return renderSimpleItem(
        bemClasses, soldOrSuspendedTxt, key, { priceSold: soldOrSuspendedTxt }, true
      );
    }
    return null;
  }
  const minPrice = min_price;
  // TODO: Илья - "desc" для Домика должен лететь в Именительном падеже с большой буквы "Двухкомнатная квартира 61.6 кв. м." (сейчас прилетает "за двухкомнатную квартиру 61.6 кв. м.")
  const priceDesc = minPrice.desc;
  const priceCurrencyName = minPrice.currency.id === 'uah' ?
    minPrice.currency.name_short :
    minPrice.currency.names_long;
  const priceClassDisplayName = minPrice.class.displayName || '';
  const priceCurrency = `${priceCurrencyName}${priceClassDisplayName}`;
  const priceBeginText = i18n('priceBeginText');
  const priceMain = beautifyNumber(minPrice.value);

  if (!bemClasses) return `${priceBeginText} ${priceMain} ${priceCurrency}`;

  let priceFullText = null;
  if (
    minPrice &&
    minPrice.value &&
    minPrice.currency &&
    minPrice.class
  ) {
    priceFullText = (
      <div {...bemClasses('price')} key={key}>
        <span {...bemClasses('text')} children={`${priceBeginText} ${priceMain} ${priceCurrency}`} />
      </div>
    );
  }

  return (
    <Fragment key={key}>
      {soldOrSuspendedTxt &&
        renderSimpleItem(
          bemClasses, soldOrSuspendedTxt, key, { priceSold: soldOrSuspendedTxt }, true
        )
      }
      <div {...bemClasses('priceMain')}>
        {priceDesc && priceFullText && renderSimpleItem(bemClasses, priceDesc, `${key}desc`, { priceDesc: true })}
        {priceFullText &&
          renderSimpleItem(bemClasses, priceFullText, key, { price: priceFullText }, true)
        }
      </div>
    </Fragment>
  );
}

export function renderSoldData(bemClasses, soldData = {}, sales_suspended_until) {
  const { i18n } = this;
  const { all_commercial_sold, all_house_and_area_sold, all_flats_sold } = soldData;
  const allCommSold = all_commercial_sold ?
    (<div {...bemClasses('text', 'sold')} children={i18n('allCommercialSoldTile')} />) :
    null;
  const allHouseAndAreaSold = all_house_and_area_sold ?
    (<div {...bemClasses('text', 'sold')} children={i18n('allHouseAndAreaTile')} />) :
    null;
  const allFlatsSold = all_flats_sold ?
    (<div {...bemClasses('text', 'sold')} children={i18n('allFlatsSoldTile')} />) :
    null;

  let soldOrSuspendedTxt = null;

  // проверка приостановлены ли продажи
  if (sales_suspended_until) {
    soldOrSuspendedTxt = <div {...bemClasses('text', 'sold')} children={i18n('salesSuspendedUntil')} />;
  }

  // проверка проданы ли все квартиры
  if (all_commercial_sold || all_house_and_area_sold || all_flats_sold) {
    soldOrSuspendedTxt = (
      <>
        {allFlatsSold}
        {allCommSold}
        {allHouseAndAreaSold}
      </>
    );
  }

  return soldOrSuspendedTxt;
}
